import { render, staticRenderFns } from "./IssuedPassItem.vue?vue&type=template&id=08499e5e"
import script from "./IssuedPassItem.vue?vue&type=script&lang=js"
export * from "./IssuedPassItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports